import { getScriptNuvemshopService } from '../../../services/nuvemshop/getScriptNuvemshop';

export function getScriptNuvemshopAction (userIdStore, accessToken, tokenPartners) { 
	return {
		type: 'GET_SCRIPT',
		payload: getScriptNuvemshopService(userIdStore, accessToken, tokenPartners)
	}
}